import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { Collection } from '@/types/source-types';

// This is now only used for error responses
export interface GetCollectionsResponse {
  detail: string;
}

// The response is now an array of Collection objects
export type CollectionsResponse = Collection[];

export const getCollections = async (
  onlyUnstructured?: boolean,
): Promise<CollectionsResponse | GetCollectionsResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const searchParams = new URLSearchParams();
  if (onlyUnstructured) {
    searchParams.set('data-type', 'unstructured');
  }

  const response = await apiRequest<CollectionsResponse>({
    url: `/collections/${orgId}?${searchParams.toString()}`,
    method: 'GET',
    target: 'platform',
  });

  // If there's an error detail, return it
  if (response.detail) {
    return {
      detail: response.detail,
    };
  }

  // If we have data and it's an array, return it
  if (response.data && Array.isArray(response.data)) {
    return response.data;
  }

  // If we get here, something unexpected happened
  return {
    detail: 'Unexpected response format',
  };
};
